import { initializeAppEnv } from './initializeAppEnv';

const storedEnv = localStorage.getItem('smtr-appEnv');
const appEnv = storedEnv ? JSON.parse(storedEnv) : initializeAppEnv();
export default appEnv;
